export default __webpack_public_path__ + "static/media/totalUser.4d5b5b2f.svg";